module.exports = __webpack_public_path__ + "img/img9.9b6f747c.jpg";